import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import moment from "moment";

/* ── Step marker images ── */
import step1Img from "../../assets/image/Group 110901.png";
import step2Img from "../../assets/image/Group 110902.png";
import step3Img from "../../assets/image/Group 110919.png";
import formBgImg from "../../assets/image/Group 2147206200.png";
import about from "../../assets/image/about_nha_pg_logo.png";

const STEPS = [
  {
    img: step1Img,
    title: "Verify Aadhaar Details",
    desc: "Enter your Aadhaar number and verify with OTP received on Aadhaar linked mobile number.",
  },
  {
    img: step2Img,
    title: "Link mobile number with ABHA",
    desc: "Enter your mobile number and verify with OTP to link with ABHA Address.",
  },
  {
    img: step3Img,
    title: "Create your ABHA",
    desc: "Create your ABHA Number with a unique ABHA address.",
  },
];

const PatientList = ({ setPatient, setCurrentStep }) => {
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [patients, setPatients] = useState([]);

  useEffect(() => {
    patientDetail();
  }, []);

  function patientDetail() {
    const savedPatientDetails = localStorage.getItem("patientDetails");
    if (savedPatientDetails) {
      try {
        const parsedPatients = JSON.parse(savedPatientDetails);
        if (Array.isArray(parsedPatients)) {
          setPatients(parsedPatients.filter(item => (!item.healthIdNumber || item.is_scanned === 1)));
        } else {
          setPatients([]);
        }
      } catch (error) {
        console.error("Error parsing patient details:", error);
        setPatients([]);
      }
    } else {
      setPatients([]);
    }
  }

  const handlePatientClick = (index) => {
    setSelectedIndex(index);
    const patient = patients[index];
    localStorage.setItem("selectedIndex", JSON.stringify(patient));
    const data = localStorage.getItem("selectedIndex");
    if (data) {
      try {
        const parsedData = JSON.parse(data);
        setPatient(parsedData);
        setCurrentStep("ConfirmPatientDetail");
      } catch (error) {
        console.error("Error parsing stored patient data:", error);
      }
    }
  };

  return (
    <>
      <section className="lmop-section">
        <div className="container">
          <h2 className="lmop-left-title">Create ABHA Number in 3 Steps</h2>
          <p className="lmop-left-desc">
            Create ABHA and store all your medical records in one place.
            Take part in the{" "}
            <span className="highlight">Ayushman Bharat Digital Mission (ABDM)</span>{" "}
            and get started on your digital health journey.
          </p>

          <div className="row align-items-start g-4 g-lg-5">

            {/* ── LEFT: 3 Steps ── */}
            <div className="col-12 col-md-6">
              <div className="lmop-steps">
                {STEPS.map((step, idx) => (
                  <React.Fragment key={idx}>
                    <div className="lmop-step-item">
                      <div className="lmop-step-marker">
                        <img src={step.img} alt={`Step ${idx + 1}`} />
                      </div>
                      <div className="lmop-step-body">
                        <h4>{step.title}</h4>
                        <p>{step.desc}</p>
                      </div>
                    </div>
                    {idx < STEPS.length - 1 && <div className="lmop-step-line" />}
                  </React.Fragment>
                ))}
              </div>
            </div>

            {/* ── RIGHT: Patient List Card ── */}
            <div className="col-12 col-md-6">
              <div
                className="lmop-card-wrap"
                style={{
                  backgroundImage: `url(${formBgImg})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <div className="lmop-card-inner">
                  <h3 className="lmop-card-title">Select Your AbyM Profile</h3>
                  <p className="lmop-card-subtitle">
                    Select profile to Create/Link your ABHA
                  </p>

                  <form>
                    <div className="patient-profile">
                      {patients?.length > 0 ? (
                        patients.map((patient, index) => (
                          <div
                            key={index}
                            className={`col-12 d-flex align-items-center bg-white p-3 mb-2 rounded ${
                              selectedIndex === index ? "border border-primary" : ""
                            }`}
                            style={{ cursor: "pointer" }}
                            onClick={() => handlePatientClick(index)}
                          >
                            <div
                              className="avatar-initial me-3 d-flex align-items-center justify-content-center text-white fw-bold"
                              style={{
                                width: "50px",
                                height: "50px",
                                borderRadius: "50%",
                                backgroundColor: "#007bff",
                                fontSize: "20px",
                                textTransform: "uppercase",
                                flexShrink: 0,
                              }}
                            >
                              {patient.fname?.charAt(0) || patient.fullname?.charAt(0)}
                            </div>
                            <div>
                              <h5 className="mb-1 patient-name">
                                {patient.fname
                                  ? patient.fname + " " + patient.lname
                                  : patient.fullname}
                              </h5>
                              <div className="d-flex flex-wrap gap-2 patient-self">
                                <span>Self |</span>
                                <span>{patient.gender} |</span>
                                <span>{patient.dob}</span>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="text-left d-flex flex-column text-center">
                          <p>
                            No patient profiles available or all patients have
                            linked their ABHA with us.
                          </p>
                          <div>
                            <button
                            type="button"
                            onClick={() => window.location.reload()}
                            className="continue-btn-back"
                          >
                            Try Different Account
                          </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </form>

                  <div className="lmop-nha-row">
                    <span className="lmop-nha-label">Approved by NHA</span>
                    <img src={about} alt="NHA Logo" className="lmop-nha-logo" />
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default PatientList;